import React from "react"

interface SearchIconProps {
  className?: string
  stroke?: string
}

function SearchIcon(props: Readonly<SearchIconProps>) {
  const { className, stroke } = props
  const cssClassName = className ?? ""
  const cssStroke = stroke ?? "#8083A3"
  return (
    <span className="anticon anticon-search ">
      <svg
        className={cssClassName}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke={cssStroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9.583 17.5a7.917 7.917 0 100-15.833 7.917 7.917 0 000 15.833zM18.333 18.333l-1.666-1.666"
        />
      </svg>
    </span>
  )
}

export default SearchIcon
